export const CLEAN_FORM = 'fuerzaventas/metas/clean-form';
export const SET_STATE_FORM = 'fuerzaventas/metas/set-state-form';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/metas/update-field-filter';
export const RECEIVE_V_LIST = 'fuerzaventas/metas/receive-v-list';
export const REQUEST_V_LIST = 'fuerzaventas/metas/request-v-list';
export const ERROR_V_LIST = 'fuerzaventas/metas/error-v-list';
export const SET_MASK = 'fuerzaventas/metas/set-mask';
export const RECEIVE_DATA= 'fuerzaventas/metas/receibe-data';
export const UPDATE_TABLE_COLUMN= 'fuerzaventas/metas/update-table-column';
export const SET_PAGE = 'fuerzaventas/metas/set-page';
export const SET_SELECTED_ROW = 'fuerzaventas/metas/set-selected-row';
export const SET_ORDER = 'fuerzaventas/metas/set-order';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';